// src/features/monetize/components/ViewersTab.tsx
//
// Viewers: look one up by the address they sign in with, then grant access,
// refund a purchase, extend or revoke a row, end a subscription — every
// action with a reason that lands in the viewer's history.

import { useState, type FormEvent } from 'react';
import { Alert, Button, Group, Skeleton, Stack, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useViewerLookup } from '../useViewerLedger';
import { ViewerLedgerPanel } from './ViewerLedgerPanel';

export function ViewersTab() {
  const [typed, setTyped] = useState('');
  const [email, setEmail] = useState('');
  const { viewer, notFound, isLoading, isError, error } = useViewerLookup(email);

  function submit(e: FormEvent) {
    e.preventDefault();
    setEmail(typed.trim());
  }

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Find a viewer by the e-mail address they sign in with. From there you can grant free access, refund a purchase or end a subscription; everything you do goes in the viewer's history.
      </Text>
      <form onSubmit={submit}>
        <Group align="flex-end">
          <TextInput
            label="Viewer e-mail"
            placeholder="viewer@example.com"
            type="email"
            autoComplete="off"
            value={typed}
            onChange={(e) => setTyped(e.currentTarget.value)}
            style={{ flex: 1, maxWidth: 420 }}
          />
          <Button type="submit" leftSection={<IconSearch size={16} />} loading={isLoading} disabled={typed.trim() === ''}>
            Look up
          </Button>
        </Group>
      </form>
      {notFound && (
        <Alert color="gray">
          No viewer has signed in with <strong>{email}</strong>. A viewer appears here after their first sign-in on your site or in your player.
        </Alert>
      )}
      {isError && <Alert color="red">{error instanceof Error ? error.message : 'The lookup failed.'}</Alert>}
      {isLoading && <Skeleton height={120} />}
      {viewer && !isLoading && <ViewerLedgerPanel viewerId={viewer.id} />}
    </Stack>
  );
}
